import Vue from 'vue'

export default {
  products(query) {
    return Vue.http.post(`/api/local/v1/search/products`, { query: query })
              .then((response) => Promise.resolve(response.data))
              .catch((error) => Promise.reject(error))
  }
}
